import React from 'react';
import StatCard from 'components/v2/StatCard';
import { getClassName } from 'utils/ui/classes';
import { useTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';

export default function ManagedAccountingSummary({
  receivableTotal,
  payableTotal,
  customerType,
  currency,
}) {
  let columns = 2;
  const { t } = useTranslation();
  const className = getClassName(
    'grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:divide-y-0 md:divide-x mb-4',
    {
      'md:grid-cols-2': columns === 2,
      'md:grid-cols-3': columns === 3,
      'md:grid-cols-4': columns === 4,
      'md:grid-cols-5': columns === 5,
      'sm:max-w-lg': columns < 4,
    },
  );

  return (
    (<dl data-testid="dl-464bc42e" className={className}>
      <StatCard
        dataTestId="StatCard-afea4aa8"
        title={t('CUSTOMER_RECEIVABLES_TOTAL', { customerType })}
        key={`${customerType.toLowerCase()}_receivable_total`}>
        <div
          data-testid="div-c6b0c6c9"
          className="flex items-baseline text-lg font-medium text-gray-800">
          {formatMoney(receivableTotal, currency)}
        </div>
      </StatCard>
      <StatCard
        dataTestId="StatCard-a47dee46"
        title={t('CUSTOMER_PAYABLES_TOTAL', { customerType })}
        key={`${customerType.toLowerCase()}_payable_total`}>
        <div
          data-testid="div-cf9fd4f9"
          className="flex items-baseline text-lg font-medium text-gray-800">
          {formatMoney(payableTotal, currency)}
        </div>
      </StatCard>
    </dl>)
  );
}
